const dayDispArr = [
  '日', '月', '火', '水', '木', '金', '土'
]

function dateStrToDate(str) {
  if (!str) { return null }

  let m
  m = str.match(/^(\d{4})[^\d](\d{2})[^\d](\d{2})$/)
  if (m) {
    // yyyy/mm/dd的な
    return new Date(m[1], m[2] - 1, m[3])
  }
  m = str.match(/^(\d{2})[^\d](\d{2})[^\d](\d{4})$/)
  if (m) {
    // dd/mm/yyyy的な
    return new Date(m[3], m[2] - 1, m[1])
  }

  m = str.match(/^(\d{4})年(\d{2})月(\d{2})日$/)
  if (m) {
    // yyyy年mm月dd日的な
    return new Date(m[1], m[2] - 1, m[3])
  }

  /*
   * 2018-12-10 12:13:14
   * 2018-12-10 12:13:14Z
   * 2018-12-10 12:13:14+0900
   * 2018-12-10T12:13:14+0900
   * 2018-12-10 12:13:14.000Z
   * 2018-12-10 12:13:14.000+0900
   * 2018-12-10T12:13:14.000+0900
   * 2018-12-10T12:13:14.000+09:00
   * timezone部分は2桁or4桁に対応(コードは2-4桁になってしまってるけど)
   */
  m = str.match(/^(\d{4})[^0-9](\d{2})[^0-9](\d{2})[^0-9](\d{2})[^0-9](\d{2})[^0-9](\d{2})(\.\d{3})?(Z)?([+-]\d{2,4})?([+-]\d{2}[^0-9]\d{2})?$/)
  if (m) {
    const year = m[1]
    const month = parseInt(m[2]) - 1
    const date = m[3]
    const hours = m[4]
    const minutes = m[5]
    const seconds = m[6]
    const mseconds = m[7] ? m[7].slice(1) : 0
    if (m[8]) {
      return new Date(Date.UTC(year, month, date, hours, minutes, seconds, mseconds))
    } else {
      return new Date(year, month, date, hours, minutes, seconds, mseconds)
    }
  }

  return null
}

export function ensureDate(dt) {
  if (!dt) { return null }

  let ret = dt
  if (typeof dt === 'string') {
    ret = dateStrToDate(dt)
  }
  return ret
}

export const dtFormat = (date, format = 'yyyy/mm/dd HH:MM:SS') => {
  date = ensureDate(date)
  if (!date || isNaN(date.valueOf())) { return '' }
  const y = date.getFullYear()
  const m = date.getMonth() + 1
  const d = date.getDate()
  const h = date.getHours()
  const min = date.getMinutes()
  const s = date.getSeconds()
  const ms = date.getMilliseconds()
  const youbi = dayDispArr[date.getDay()]
  return format
    .replace(/yyyy/g, y)
    .replace(/mm/g, ('0' + m).slice(-2))
    .replace(/m/g, m)
    .replace(/dd/g, ('0' + d).slice(-2))
    .replace(/d/g, d)
    .replace(/HH/g, ('0' + h).slice(-2))
    .replace(/H/g, h)
    .replace(/MM/g, ('0' + min).slice(-2))
    .replace(/M/g, min)
    .replace(/SS/g, ('0' + s).slice(-2))
    .replace(/S/g, s)
    .replace(/\.sss/g, '.' + ('00' + ms).slice(-3))
    .replace(/\.ss/g, '.' + ('0' + ms).slice(-2))
    .replace(/\.s/g, '.' + ms)
    .replace(/a/g, youbi)
}

export const fuzzyTimeDisp = (compDate, baseDate) => {
  baseDate = ensureDate(baseDate)
  compDate = ensureDate(compDate)
  const secDiff = (baseDate - compDate) / 1000

  if (secDiff < 60) {
    return `${Math.round(secDiff)}秒前`
  } else if (secDiff < 3600) {
    const minDiff = Math.round(secDiff / 60)
    return `${minDiff}分前`
  } else if (secDiff < 86400) {
    const hourDiff = Math.round(secDiff / 3600)
    return `${hourDiff}時間前`
  } else {
    const baseY = baseDate.getFullYear()
    const baseM = baseDate.getMonth()
    const baseD = baseDate.getDate()
    const compY = compDate.getFullYear()
    const compM = compDate.getMonth()
    const compD = compDate.getDate()
    if (secDiff < 86400 * 31) {
      // xx日前と表示する場合は、カレンダー的な日数の差でないとしっくりこない
      const tmpBaseDate = new Date(baseY, baseM, baseD)
      const tmpCompDate = new Date(compY, compM, compD)
      const dayDiff = Math.round((tmpBaseDate - tmpCompDate) / 86400 / 1000)
      return `${dayDiff}日前`
    } else if (baseY === compY) {
      return `${compM + 1}月${compD}日`
    } else {
      return `${compY}年${compM + 1}月${compD}日`
    }
  }
}
